import { Outlet } from 'react-router-dom';
import SharedErrorBoundary from '../../../../shared/shared-error-boundary';
import { pagesConfig } from '../../../../shared/pages-config';
import GpanelContactsLabels from './gpanel-contacts-labels/gpanel-contacts-labels';
import GpanelContactsTrashNavigation from './gpanel-contacts-trash-navigation';
import GpanelContactsSyncNavigation from './gpanel-contacts-sync-navigation.tsx';
import SimpleBreadcrumbsPage from '../../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../../shared/analytics/module-list';
import {
  GPanelContactsPermissions,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles.ts';
import { useUserSettings } from '../../../../utils/use-user-settings.tsx';

import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

export default function GpanelContactsPage() {
  const { gPanelContactsRoles } = useUserSettings();
  const isAbleToSeeContactSync = isAbleToSeeUIElement(
    gPanelContactsRoles,
    GPanelContactsPermissions.ViewContactSyncs.value
  );

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.directory.name },
        { label: pagesConfig.gpanelContacts.name },
      ]}
      bookmarkKey={pagesConfig.gpanelContacts.value}
    >
      <Stack
        flexDirection="row"
        gap={1}
        sx={{
          width: '100%',
          overflow: 'hidden',
          flexGrow: 1,
          height: '100%',
        }}
      >
        <Card
          sx={{
            width: 350,
            minHeight: 700,
            overflow: 'auto',
            height: '100%',
          }}
        >
          <SharedErrorBoundary section="Directory - gPanel Contacts: Labels">
            <Stack
              flexDirection="column"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                height: '100%',
                overflow: 'hidden',
                flexGrow: 1,
                pr: 1,
              }}
            >
              <Container
                sx={{
                  '&': {
                    p: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  },
                }}
              >
                <GpanelContactsLabels />
              </Container>
              <Container sx={{ '&': { p: 0 }, flexGrow: 1 }}>
                {isAbleToSeeContactSync && (
                  <>
                    <Divider variant="middle" sx={{ '&': { mr: 0 } }} />
                    {isAbleToSeeContactSync && (
                      <div style={{ marginLeft: '8px' }}>
                        <GpanelContactsSyncNavigation />
                      </div>
                    )}
                  </>
                )}
                <GpanelContactsTrashNavigation />
              </Container>
            </Stack>
          </SharedErrorBoundary>
        </Card>
        <Card sx={{ flexGrow: 1, minHeight: 400 }}>
          <Outlet />
        </Card>
      </Stack>
    </SimpleBreadcrumbsPage>
  );
}
